import styled, { createGlobalStyle } from 'styled-components';

export const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const GridContainer = styled.div<{ size?: number; gap?: number }>`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: ${(props) => props.gap || 2}px;
  width: ${(props) => props.size || 64}px;
  height: ${(props) => props.size || 64}px;
`;

export const LoaderGlobalStyle = createGlobalStyle`
  @keyframes pulse1 {
    0%, 100% { 
      opacity: 0.4; 
      transform: scale(0.95); 
      background-color: #0ffee6; /* Base color */
    }
    25% { 
      opacity: 1; 
      transform: scale(1); 
      background-color: #0ffee6; /* Pulsing color updated */
      box-shadow: 0 0 10px rgba(15, 254, 230, 0.5); /* Updated shadow color */
    }
  }
  
  @keyframes pulse2 {
    0%, 100% { 
      opacity: 0.4; 
      transform: scale(0.95); 
      background-color: #0ffee6; /* Base color */
    }
    25%, 50% { 
      opacity: 1; 
      transform: scale(1); 
      background-color: #0ffee6; /* Pulsing color updated */
      box-shadow: 0 0 10px rgba(15, 254, 230, 0.5); /* Updated shadow color */
    }
  }
  
  @keyframes pulse3 {
    0%, 100% { 
      opacity: 0.4; 
      transform: scale(0.95); 
      background-color: #0ffee6; /* Base color */
    }
    50%, 75% { 
      opacity: 1; 
      transform: scale(1); 
      background-color: #0ffee6; /* Pulsing color updated */
      box-shadow: 0 0 10px rgba(15, 254, 230, 0.5); /* Updated shadow color */
    }
  }
  
  @keyframes pulse4 {
    0%, 100% { 
      opacity: 0.4; 
      transform: scale(0.95); 
      background-color: #0ffee6; /* Base color */
    }
    75% { 
      opacity: 1; 
      transform: scale(1); 
      background-color: #0ffee6; /* Pulsing color updated */
      box-shadow: 0 0 10px rgba(15, 254, 230, 0.5); /* Updated shadow color */
    }
  }
`;

interface BoxProps {
  animationName: 'pulse1' | 'pulse2' | 'pulse3' | 'pulse4';
  delay: number;
}

export const Box = styled.div<BoxProps>`
  background-color: #0ffee6; /* Base color */
  border-radius: 2px;
  opacity: 0.4;
  animation-name: ${(props) => props.animationName};
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-delay: ${(props) => props.delay}s;
`;

interface SquareLoaderProps {
  size?: number;
  gap?: number;
}

export function SquareLoader({ size = 24, gap = 2 }: SquareLoaderProps) {
  return (
    <LoaderContainer>
      <LoaderGlobalStyle />
      <GridContainer size={size} gap={gap}>
        <Box animationName="pulse1" delay={0} />
        <Box animationName="pulse2" delay={0.5} />
        <Box animationName="pulse4" delay={1.5} />
        <Box animationName="pulse3" delay={1} />
      </GridContainer>
    </LoaderContainer>
  );
}
